/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import { areDeepEqual } from 'fierry/type/compare';


export default class Entity
{
  static children = [];


  static getInitialState (cass)
  {
    return this.children.reduce((state, child) => state.set(child, Immutable.Map()), Immutable.Map({ cass: Object.freeze(cass) }));
  }


  static load (cursor, cass, parent)
  {
    if (!cursor.has())
    {
      cursor.set(this.getInitialState(cass));
    }
    else if (!areDeepEqual(this.at(cursor, parent).cass, cass))
    {
      this.at(cursor, parent).cass = cass;
    }

    return this.at(cursor, parent);
  }


  static at (cursor, parent)
  {
    if (!cursor.has())
    {
      return null;
    }

    return new this(cursor, parent);
  }


  constructor (cursor, parent = null)
  {
    this.cursor = cursor;
    this.parent = parent;
  }


  set (values)
  {
    this.cass = { ...this.cass, ...values };
  }


  set cass (cass)
  {
    this.cursor.child('cass').set(Object.freeze(cass));
  }


  get cass ()
  {
    return this.cursor.child('cass').get();
  }


  getID ()
  {
    return this.cass.id;
  }


  equals (other)
  {
    if (other?.constructor === this.constructor && this.cursor.get() === other.cursor.get())
    {
      if (this.parent === null || other.parent === null)
      {
        return this.parent === other.parent;
      }

      return this.parent.cursor.get() === other.parent.cursor.get();
    }

    return false;
  }


};
